import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router";
import { Card, CardHeader, CardBody, Row, Col, CardTitle } from "reactstrap";
import { connect } from "react-redux";
import Dashboard from "../Dashboard";
import DashboardSingleDemo from "../DashboardSingleDemo";
import Superadmin from "../views/Superadmin";

//check if the roles of the user are included into the roles of the route
let checkRoles = (arr, target) => target.some((r) => arr.includes(r));

const PrivateRoute = ({
  component: Component,
  isAuthenticated,
  user,
  roles,
  name,
  version,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (isAuthenticated) {
        //se è un utente superadmin chiedo quale azienda vedere altrimenti proseguo nella dashboard
        if (user.company === null && checkRoles(user.roles, ["superadmin"])) {
          return <Superadmin {...props} name={name} user={user} />;
        } else if (user.company !== null && checkRoles(user.roles, ["demo_single"])) {
          return <DashboardSingleDemo {...props} name={name} user={user} version={version} />
        } else if (user.company !== null && checkRoles(user.roles, roles)) {
          return (
            <Dashboard {...props} name={name} user={user} version={version}>
              <Component {...props} name={name} user={user} />
            </Dashboard>
          );
        } else {
          return (
            <Dashboard {...props} name={name}>
              <div className="content">
                <Row>
                  <Col md="12">
                    <Card className="card-chart">
                      <CardHeader>
                        <CardTitle tag="h3">
                          <i className="tim-icons icon-alert-circle-exc text-info" />{" "}
                          Attenzione
                        </CardTitle>
                      </CardHeader>
                      <CardBody>
                        <p>
                          Non sei abilitato ad utilizzare questa funzionalità.
                        </p>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Dashboard>
          );
        }
      } else {
        return (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location },
            }}
          />
        );
      }
    }}
  />
);

PrivateRoute.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.Auth.isAuthenticated,
  user: state.Auth.user,
});

export default connect(mapStateToProps)(PrivateRoute);
